import { cn } from "@fatbees/ui-utils";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import * as React from "react";
import { ForwardedRef, forwardRef } from "react";

export type PopoverProps = React.ComponentProps<typeof PopoverPrimitive.Root>;

export interface PropoverContentProps extends React.ComponentProps<
  typeof PopoverPrimitive.Content
> {
  className?: string;
}

function Popover({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Root>) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />;
}

function PopoverTrigger({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
}

export const PopoverContent = forwardRef(function PopoverContent(
  { className, ...props }: PropoverContentProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        data-slot="popover-content"
        ref={ref}
        className={cn(
          [
            "bg-popover",
            "text-popover-foreground",
            "data-[state=open]:animate-in",
            "data-[state=closed]:animate-out",
            "data-[state=closed]:fade-out-0",
            "data-[state=open]:fade-in-0",
            "data-[state=closed]:zoom-out-95",
            "data-[state=open]:zoom-in-95",
            "data-[side=bottom]:slide-in-from-top-2",
            "data-[side=left]:slide-in-from-right-2",
            "data-[side=right]:slide-in-from-left-2",
            "data-[side=top]:slide-in-from-bottom-2",
            "z-50",
            "w-72",
            "origin-(--radix-popover-content-transform-origin)",
            "rounded-md",
            "border",
            "p-4",
            "shadow-md",
            "outline-hidden",
          ],
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
});

function PopoverAnchor({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Anchor>) {
  return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />;
}

export { Popover, PopoverTrigger, PopoverAnchor };
export { PopoverClose } from "@radix-ui/react-popover";
